import axios from 'axios';
import Vue from 'vue';
import {getNotificationsApiUrl} from '../../utils/config';

const fetchRoles = (userId) => {
  const url = getNotificationsApiUrl() + "/notifications/draft/approverUsers";
  return axios.get(url,
    {
      headers: Vue.prototype.$OAuth.buildHttpHeader({
        "adfs":"true"
      })
    })
    .then(response => {
      if (!userId) {
        return '';
      }
      // find the role for the user - supposedly there's only a single result for each user ATM
      const result = response.data.find(e => e.userId.toLowerCase() === userId.toLowerCase());
      return result ? result.role : ''; 
    })
    .catch(err => {
      // eslint-disable-next-line
      console.error(err);
      throw err;
    });
};

export default { fetchRoles };
